import { render, staticRenderFns } from "./CloseCasesTable.vue?vue&type=template&id=56983692&scoped=true&"
import script from "./CloseCasesTable.vue?vue&type=script&lang=ts&"
export * from "./CloseCasesTable.vue?vue&type=script&lang=ts&"
import style0 from "./CloseCasesTable.vue?vue&type=style&index=0&id=56983692&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56983692",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\vNextBuildV3\\29\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('56983692', component.options)
    } else {
      api.reload('56983692', component.options)
    }
    module.hot.accept("./CloseCasesTable.vue?vue&type=template&id=56983692&scoped=true&", function () {
      api.rerender('56983692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueApp/views/Customer/Cases/Close/components/CloseCasesTable.vue"
export default component.exports